// -----------------------------------------------------//
// SAVE FORM FIELD SELECTIONS IN COOKIES 		//
// formcookie_saverestore.js				//
// -----------------------------------------------------//

// instructions:
// ------------
// Change <BODY>
// to <BODY onunload="saveSelections(document.forms[0])"> and
// Change </FORM>
// TO </FORM><SCRIPT language=JavaScript type="">loadSelections(document.forms[0]);</SCRIPT>
//

//
// ------------------------------------------------
// This function will concatentate all the fields in
// in the form into one string, delimited by a PIPE
// symbol, into one cookie. The cookie name is the
// same name as the form name. ALL fields are saved.
// ------------------------------------------------
//


function saveSelections(frm) {
  var setvalue;
  var fieldType;
  var fieldValue;
  var index;
  var formname = frm.id;
  
  var today = new Date();
  var exp   = new Date(today.getTime()+1*60*1000);

  var stringCookie = "formname=" + formname + "|";
  var cookieName = formname;

  var n = frm.length;
  for (i = 0; i < n; i++)
  {
    e = frm[i].id;
    fieldValue  = frm[i].value;
    fieldType   = frm[i].type;
    fieldChecked = frm[i].checked;

    if(e.indexOf("updates_") > -1)
    {              
      continue;
    }
    //
    // RADIO BUTTON
    //
    if (fieldType == "radio") {
      if (fieldChecked) {
      	stringCookie = stringCookie + frm.elements[e].name + "\_" + frm.elements[e].value + "\|";
      }
    }
    
    //
    // CHECKBOX
    // CONCATENATING FIELD_NAME AND FIELD_VALUE IS DONE DIFFERENTLY.
    // BECAUSE QUALIFICATION CHECKBOX LIST HAS THE SAME NAME FOR EACH INPUT.
    // SO WE HAVE TO UTILISE ITS id
    //
    if (fieldType == "checkbox") {
      if (fieldChecked) {
      	stringCookie = stringCookie + "attributes[" + e + "]\_" + fieldValue + "\|";
      }
    }
    
    //
    // TEXT, TEXTAREA, and DROPDOWN
    //
    if (fieldType == "number" || fieldType == "text" || fieldType == "textarea" || fieldType == "select-one")
    {
      	stringCookie = stringCookie + frm.elements[e].name + "\_" + frm.elements[e].value + "\|";                
    }


  }
  //console.log(stringCookie);
  setCookie(cookieName, stringCookie, exp); 
}

//
// LOAD FORM FIELD SELECTIONS FROM SAVED COOKIES
//

function loadSelections(frm) {
  var z=0;
  var i=0;  
  var cookieName;
  var fieldArray;
  var fieldValues;

  var formname = frm.id;
  // Retrieve form elements from cookie and split into array.
  cookieName  = formname;
  fieldValues = getCookie(cookieName);  
  fieldArray  = fieldValues.split("|").slice(1);

  var n = frm.length;
  var $eles = $(":input[name^='attributes']")

  for (i = 0; i < $eles.length; i++) {
    e = $eles[i]			
    var fieldType  = e.type;
    var fieldName = fieldArray[z].split("_")[0]
	var fieldValue = fieldArray[z].split("_")[1];
    
    if (e.name == fieldName || ("attributes[" + e.id + "]" == fieldName)) {

      if (fieldType == "number" || fieldType == "text"  || fieldType == "textarea") {
          e.value = fieldValue;
	      z += 1;
      }

      if (fieldType == "select-one") {
        var y = 0;
        $.each(e.options, function(index) {
          if (e.options[index].value == fieldValue) {
            e.options.selectedIndex = index;
		    z += 1;
          }
        });
      }
    
      if (fieldType == "checkbox") {
        if (fieldValue == e.value) {
          e.checked = true;
	      z += 1;
        }
      }

      if (fieldType == "radio") {
        var lstRadio = $(":input[name='" + e.name + "']");
        var x = lstRadio.length;
        $.each(lstRadio, function(index) {
          if (lstRadio[index].value == fieldValue) {
            lstRadio[index].checked = true;
		    z += 1;
          }
        });
        
        i = i + (x-1);

        if(fieldValue == 'drivers licence')
        {                   	
          showCurrentPOI('.row-licence');
        }

        if(fieldValue == 'birth certificate and photo ID')
        {                   	
          showCurrentPOI('.row-birth-certificate');
        }

        if(fieldValue == 'certificate of registration by descent and photo ID')
        {                   	
          showCurrentPOI('.row-cordb');
        }

        if(fieldValue == 'passport')
        {                   	
          showCurrentPOI('.row-passport');
        }

        if(fieldValue == 'citizenship certificate and photo ID')
        {                   	
          showCurrentPOI('.row-citizenship');
        }

        if(fieldValue == 'medicare card and photo ID')
        {                   	
          showCurrentPOI('.row-medicare');
        }
        
        if (fieldName.indexOf("other-language") > 0) {
          if(fieldValue == "yes") {
            $('#row-language').show();           
          }
        }
        
        if (fieldName.indexOf("disability") > 0) {
          if(fieldValue == "yes") {
            $('#row-disability-type').show();           
          }
        }
        
        if (fieldName.indexOf("education") > 0) {
          if(fieldValue == "yes") {
            $('#row-higherEducation').show();           
          }
        }
      }

      if (fieldType == "hidden") {
        e.value = fieldValue;
        z += 1;
      }
    }
  }
}

/// COOKIE FUNCTIONS
//function setCookie(name, value, expires, path, domain, secure) {
//  document.cookie= name + "=" + escape(value) +  
//  ((path) ? "; path=" + path : "") +
//  ((domain) ? "; domain=" + domain : "") +
//  ((secure) ? "; secure" : "") +
//  ((expires) ? "; expires=" + expires.toUTCString() : "");
//}
function setCookie(name, value, expires, path, domain, secure) {
  document.cookie= name + "=" + escape(value) +  
  ((path) ? "; path=" + path : "") +
  ((domain) ? "; domain=" + domain : "") +
  ((secure) ? "; secure" : ""); 
}

function getCookie(name) {
  var dc = document.cookie;
  var prefix = name + "=";
  var begin = dc.indexOf("; " + prefix);
  
  if (begin == -1) {
  	begin = dc.indexOf(prefix);
  	if (begin != 0) return null;
  } else {
  	begin += 2;
  }
  var end = document.cookie.indexOf(";", begin);
  if (end == -1) {
  	end = dc.length;
  }
  return unescape(dc.substring(begin + prefix.length, end));
}
